/**
 * The base class for template specific controllers.
 */

import _ from 'lodash';

export default class GlobalBase {

    constructor() {
        // Run docReady on after document is loaded.
        document.addEventListener("DOMContentLoaded", () => {
            const bodyClass = _.get( this, 'bodyClass', '' );
            // If body has the defined class, run this.
            if ( bodyClass && document.querySelector( 'body' ).classList.contains( bodyClass ) ) {
                this.docReady();
            }
        });
    }
}
